module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "growth-dashboard-container"
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "page-icon-wrapper mr-3"
  }, [_c('i', {
    staticClass: "fa fa-chart-line page-icon"
  })]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "page-title mb-1"
  }, [_vm._v("Growth Dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "page-subtitle text-muted mb-0"
  }, [_c('i', {
    staticClass: "fa fa-calendar-alt mr-2"
  }), _vm._v("\n              Real-time business analytics & performance insights\n            ")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "page-actions"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-sync-alt",
    class: {
      'fa-spin': _vm.isRefreshing
    }
  }), _vm._v("\n            Refresh\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exportDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n            Export\n          ")])], 1)])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "filters-card mb-4",
    class: {
      'filters-collapsed': _vm.filtersCollapsed
    }
  }, [
    [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between w-100"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('i', {
      staticClass: "fa fa-filter text-primary mr-2"
    }), _vm._v(" "), _c('h5', {
      staticClass: "mb-0"
    }, [_vm._v("Advanced Filters")]), _vm._v(" "), (_vm.activeFiltersCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.activeFiltersCount) + " active\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": _vm.toggleFilters
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.filtersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
    })]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "outline-secondary",
        "size": "sm"
      },
      on: {
        "click": _vm.resetFilters
      }
    }, [_c('i', {
      staticClass: "fa fa-undo"
    }), _vm._v(" Reset\n            ")])], 1)])], _vm._v(" "), _c('b-collapse', {
      attrs: {
        "visible": !_vm.filtersCollapsed,
        "id": "filters-collapse"
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
      staticClass: "w-100",
      attrs: {
        "startDate": _vm.dateRange.startDate,
        "endDate": _vm.dateRange.endDate,
        "opens": 'right'
      },
      on: {
        "update": _vm.onDateRangeUpdate
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function(picker) {
          return [_c('div', {
            staticClass: "d-flex align-items-center date-range-display"
          }, [_c('i', {
            staticClass: "fa fa-calendar mr-2 text-muted"
          }), _vm._v(" "), (picker.startDate && picker.endDate) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.moment(picker.startDate).format('DD/MM/YYYY')) + " - " + _vm._s(_vm.moment(picker.endDate).format('DD/MM/YYYY')) + "\n                  ")]) : _c('span', {
            staticClass: "text-muted"
          }, [_vm._v("Select Date Range")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-caret-down ml-auto text-muted"
          })])]
        }
      }]),
      model: {
        value: (_vm.dateRange),
        callback: function($$v) {
          _vm.dateRange = $$v
        },
        expression: "dateRange"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllBranchList'],
        "option-value": "pickupId",
        "option-text": "pickupLocation",
        "placeholder": "Select Branch"
      },
      model: {
        value: (_vm.filters.branch_id),
        callback: function($$v) {
          _vm.$set(_vm.filters, "branch_id", $$v)
        },
        expression: "filters.branch_id"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("User")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllUserList'],
        "option-value": "userId",
        "option-text": "employeeName",
        "placeholder": "Select User"
      },
      model: {
        value: (_vm.filters.user_id),
        callback: function($$v) {
          _vm.$set(_vm.filters, "user_id", $$v)
        },
        expression: "filters.user_id"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("Job Type")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.jobTypeOptions,
        "option-value": "value",
        "option-text": "text",
        "placeholder": "Select Job Type"
      },
      model: {
        value: (_vm.filters.job_type),
        callback: function($$v) {
          _vm.$set(_vm.filters, "job_type", $$v)
        },
        expression: "filters.job_type"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllShippingLineList'],
        "option-value": "shippingId",
        "option-text": "shippingLine",
        "placeholder": "Select Shipping Line"
      },
      model: {
        value: (_vm.filters.shipping_line_id),
        callback: function($$v) {
          _vm.$set(_vm.filters, "shipping_line_id", $$v)
        },
        expression: "filters.shipping_line_id"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "3",
        "md": "6"
      }
    }, [_c('label', {
      staticClass: "text-muted small"
    }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.transportTypeOptions,
        "option-value": "value",
        "option-text": "text",
        "placeholder": "Select Transport Type"
      },
      model: {
        value: (_vm.filters.transport_type),
        callback: function($$v) {
          _vm.$set(_vm.filters, "transport_type", $$v)
        },
        expression: "filters.transport_type"
      }
    })], 1)], 1), _vm._v(" "), _c('b-row', {
      staticClass: "mt-3"
    }, [_c('b-col', {
      staticClass: "text-right"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-secondary"
      },
      on: {
        "click": _vm.clearFilters
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Clear All\n            ")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "primary",
        "disabled": _vm.isLoading
      },
      on: {
        "click": _vm.applyFilters
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      class: {
        'fa-spin': _vm.isLoading
      }
    }), _vm._v("\n              Apply Filters\n            ")])], 1)], 1)], 1)
  ], 2), _vm._v(" "), _c('b-card', {
    staticClass: "main-content-card"
  }, [
    [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between w-100"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('i', {
      staticClass: "fa fa-chart-bar text-primary mr-2"
    }), _vm._v(" "), _c('h5', {
      staticClass: "mb-0"
    }, [_vm._v("Analytics Dashboard")])]), _vm._v(" "), _c('div', {
      staticClass: "tab-indicators"
    }, [_c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": _vm.activeTab === 'monthly' ? 'primary' : 'light'
      }
    }, [_vm._v("\n              Monthly\n            ")]), _vm._v(" "), _c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": _vm.activeTab === 'branch-wise-monthly' ? 'secondary' : 'light'
      }
    }, [_vm._v("\n              Branches Monthly\n            ")]), _vm._v(" "), _c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": _vm.activeTab === 'branch-wise' ? 'warning' : 'light'
      }
    }, [_vm._v("\n              Branches\n            ")]), _vm._v(" "), _c('b-badge', {
      attrs: {
        "variant": _vm.activeTab === 'assignments' ? 'danger' : 'light'
      }
    }, [_vm._v("\n              Assignments\n            ")]), _vm._v(" "), _c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": _vm.activeTab === 'client-wise' ? 'success' : 'light'
      }
    }, [_vm._v("\n              Clients\n            ")]), _vm._v(" "), _c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": _vm.activeTab === 'shipping-line-wise' ? 'info' : 'light'
      }
    }, [_vm._v("\n              Shipping\n            ")])], 1)])], _vm._v(" "), _c('b-nav', {
      staticClass: "custom-tabs mb-3",
      attrs: {
        "pills": "",
        "justified": ""
      }
    }, [_c('b-nav-item', {
      staticClass: "monthly-tab",
      attrs: {
        "active": _vm.activeTab === 'monthly'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('monthly')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-alt mr-2"
    }), _vm._v("\n          Monthly Growth\n          "), (_vm.monthlyDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.monthlyDataCount) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-item', {
      staticClass: "branch-monthly-tab",
      attrs: {
        "active": _vm.activeTab === 'branch-wise-monthly'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('branch-wise-monthly')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-alt mr-2"
    }), _vm._v("\n          Branch Monthly\n          "), (_vm.branchMonthlyDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.branchMonthlyDataCount) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-item', {
      staticClass: "branch-tab",
      attrs: {
        "active": _vm.activeTab === 'branch-wise'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('branch-wise')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-building mr-2"
    }), _vm._v("\n          Branch Performance\n          "), (_vm.branchDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "warning"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.branchDataCount) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-item', {
      staticClass: "assignments-tab",
      attrs: {
        "active": _vm.activeTab === 'assignments'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('assignments')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text mr-2"
    }), _vm._v("\n          Detailed Assignments\n          "), (_vm.assignmentsDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "danger"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.assignmentsDataCount) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-item', {
      staticClass: "client-tab",
      attrs: {
        "active": _vm.activeTab === 'client-wise'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('client-wise')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users mr-2"
    }), _vm._v("\n          Client Analysis\n          "), (_vm.clientDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "success"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.clientDataCount) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-item', {
      staticClass: "shipping-tab",
      attrs: {
        "active": _vm.activeTab === 'shipping-line-wise'
      },
      on: {
        "click": function($event) {
          _vm.setActiveTab('shipping-line-wise')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ship mr-2"
    }), _vm._v("\n          Shipping Lines\n          "), (_vm.shippingDataCount > 0) ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.shippingDataCount) + "\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "tab-content"
    }, [_c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'monthly'
      },
      attrs: {
        "id": "monthly"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'monthly') ? _c('monthly-growth-component', {
      key: 'monthly-' + _vm.filterKey,
      ref: "monthlyTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'client-wise'
      },
      attrs: {
        "id": "client-wise"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'client-wise') ? _c('client-wise-growth-component', {
      key: 'client-wise-' + _vm.filterKey,
      ref: "clientWiseTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'shipping-line-wise'
      },
      attrs: {
        "id": "shipping-line-wise"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'shipping-line-wise') ? _c('shipping-line-wise-growth-component', {
      key: 'shipping-line-wise-' + _vm.filterKey,
      ref: "shippingLineWiseTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'branch-wise'
      },
      attrs: {
        "id": "branch-wise"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'branch-wise') ? _c('branch-wise-growth-component', {
      key: 'branch-wise-' + _vm.filterKey,
      ref: "branchWiseTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'branch-wise-monthly'
      },
      attrs: {
        "id": "branch-wise-monthly"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'branch-wise-monthly') ? _c('branch-wise-monthly-growth-component', {
      key: 'branch-wise-monthly-' + _vm.filterKey,
      ref: "branchWiseMonthlyTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === 'assignments'
      },
      attrs: {
        "id": "assignments"
      }
    }, [_c('div', {
      staticClass: "tab-content-wrapper"
    }, [(_vm.activeTab === 'assignments') ? _c('assignments-growth-component', {
      key: 'assignments-' + _vm.filterKey,
      ref: "assignmentsTab",
      attrs: {
        "filters": _vm.filters
      },
      on: {
        "loading": _vm.handleLoading
      }
    }) : _vm._e()], 1)])])
  ], 2), _vm._v(" "), _c('b-card', {
    staticClass: "footer-card mt-4",
    attrs: {
      "body-class": "text-center py-3"
    }
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_c('i', {
    staticClass: "fa fa-clock mr-1"
  }), _vm._v("\n        Last updated: " + _vm._s(_vm.lastUpdated) + "\n        "), _c('span', {
    staticClass: "mx-3"
  }, [_vm._v("|")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-database mr-1"
  }), _vm._v("\n        Data refreshed every 5 minutes\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105e2d30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/growthDashboard.vue
// module id = 2400
// module chunks = 0